/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-alert */
import React, { useEffect, useState } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row, Col, Card, CardBody, NavItem, NavLink,
  TabContent, TabPane, Nav, Button, Badge, CardHeader,
} from 'reactstrap';
import classnames from 'classnames';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { withTranslation } from 'react-i18next';
// import moment from 'moment';

import moment from 'moment';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

// import BaseGrid from '../../components/Common/BaseGrid';
import ShopJimmyBC from '../../components/Listing/ShopJimmyBC';
import ChannelAdvisor from '../../components/Listing/ChannelAdvisor';
import BaseGrid from '../../components/Common/BaseGrid';
import { get } from '../../helpers/api_helper';

function ViewListing(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;
  const { id } = useParams();
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [, setError] = useState(null);
  const [data, setData] = useState(null);
  const [activeTab, setActiveTab] = useState('1');
  const [activeChnTab, setActiveChnTab] = useState('0');
  const [isGallery, setIsGallery] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);
  const [refresh, setRefresh] = useState(0);
  const [availQty, setAvailQty] = useState(null);
  const [pushing, setPushing] = useState(false);

  const toggle = (tab) => {
    setActiveTab(tab);
  };

  const toggleChnTab = (tab) => {
    setActiveChnTab(tab);
  };

  const pushSync = async () => {
    setPushing(true);

    try {
      // eslint-disable-next-line no-restricted-syntax
      for await (const x of data.channels) {
        if (x.channel === 'channel_advisor') {
          await get(`/api/ca/push/${x.remote_id}`);
        } else if (x.channel === 'shopjimmy') {
          await get(`/api/bc/push/${x.remote_id}`);
        }
      }

      setRefresh((prev) => prev + 1);
    } catch (e) {
      toastr.error(e.message);
      if (e.response && e.response.data && e.response.data.error) {
        toastr.error(e.response.data.error);
      }
    } finally {
      setPushing(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const listing = await get(`/api/listings/data/${id}`);
        setData(listing);

        const qty = await get(`/api/listings/available-qty/${id}`);
        setAvailQty(qty.qty);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    fetchData();
  }, [refresh, id]);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col lg="6">
            <Card>
              <CardHeader className="text-uppercase bg-transparent border-bottom">{t('Details')}</CardHeader>
              <CardBody>
                <table className="table table-bordered table-striped responsiveTable">
                  <tbody>
                    <tr>
                      <th style={{ minWidth: '150px' }}>{t('Listing ID')}</th>
                      <td>{loading === true ? t('Loading...') : id}</td>
                    </tr>
                    <tr>
                      <th>{t('Sku')}</th>
                      <td>{loading === true ? t('Loading...') : data.sku}</td>
                    </tr>
                    <tr>
                      <th>{t('Title')}</th>
                      <td>{loading === true ? t('Loading...') : data.title}</td>
                    </tr>
                    <tr>
                      <th>{t('Condition')}</th>
                      <td>{loading === true ? t('Loading...') : data.condition}</td>
                    </tr>
                    <tr>
                      <th>{t('Price')}</th>
                      <td>{loading === true ? t('Loading...') : `$${data.price}`}</td>
                    </tr>
                    <tr>
                      <th>{t('Available Qty')}</th>
                      <td>
                        {availQty === null && (
                          <span className="text-warning">{t('Loading qty')}</span>
                        )}
                        {availQty !== null && (
                          availQty === 0 ? t('Out of stock') : availQty
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th>{t('Tags')}</th>
                      <td>
                        {loading === true ? t('Loading...') : (
                          <div>
                            {data && data.tags.map((x) => (
                              <Badge key={x.id} color="primary" size="sm" className="badge-soft-primary text-dark me-1 p-1">{x.label}</Badge>
                            ))}
                          </div>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th>{t('Channels')}</th>
                      <td>
                        {loading === true ? t('Loading...') : (
                          <div>
                            {data && data.channels.map((x) => (
                              <Badge key={x.id} color="light" size="sm" className="text-dark me-1 p-1">{x.channel}</Badge>
                            ))}
                          </div>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
                {data && (
                  <Button color="primary" title={t('Edit Listing')} onClick={() => { history.push(`/listings/edit/${id}`); }}>
                    <span className="mdi mdi-pencil" />
                  </Button>
                )}

                {data && (
                  <Button color="primary" title={t('Duplicate Listing')} className="ms-2 p-1 btn-soft-primary" onClick={() => { history.push(`/listings/duplicate/${id}`); }}>
                    <span className="mdi mdi-content-duplicate fs-5" />
                  </Button>
                )}
              </CardBody>
            </Card>

            <Card>
              <CardHeader className="text-uppercase bg-transparent border-bottom">{t('Images')}</CardHeader>
              <CardBody>
                <div>
                  <div className="popup-gallery hstack gap-2">
                    {(data === null || (!data.images || data.images.length === 0)) && (
                      <div className="img-fluid mt-2">
                        <p>{t('No images explicitly uploaded')}</p>
                      </div>
                    )}
                    {data !== null && data.images
                      && data.images.length > 0 && data.images.map((x, i) => (
                        <div key={x.id} className="img-fluid mt-2">
                          <img
                            src={x.url}
                            alt={x.alt}
                            style={{
                              cursor: 'pointer', width: '100%', maxWidth: '200px', maxHeight: '200px',
                            }}
                            onClick={() => { setIsGallery(true); setImageIndex(i); }}
                          />
                        </div>
                    ))}
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col lg="5">
            {loading === true ? t('Loading...') : (
              <>
                <Nav tabs>
                  {data && data.channels.map((x, i) => (
                    <NavItem key={`chn_tab_lnk_${x.id}`}>
                      <NavLink
                        style={{ cursor: 'pointer' }}
                        className={classnames({
                          active: (activeChnTab === i.toString()),
                        })}
                        onClick={() => {
                          toggleChnTab(i.toString());
                        }}
                      >
                        {x.channel}
                      </NavLink>
                    </NavItem>
                  ))}
                </Nav>
                <TabContent
                  activeTab={activeChnTab.toString()}
                >
                  {data && data.channels.map((x, i) => (
                    <TabPane key={`chn_tab_${x.id}`} tabId={i.toString()}>
                      <Card className="border border-light border-top-0" style={{ borderRadius: '0px' }}>
                        <CardBody>
                          {x.channel === 'shopjimmy' && (
                            <ShopJimmyBC remoteId={x.remote_id} listing={data} />
                          )}

                          {x.channel === 'channel_advisor' && (
                            <ChannelAdvisor
                              remoteId={x.remote_id}
                              listing={data}
                              channel={x}
                            />
                          )}
                        </CardBody>
                      </Card>
                    </TabPane>
                  ))}
                </TabContent>
                <Card>
                  <CardBody>
                    <Button
                      color="primary"
                      onClick={pushSync}
                      disabled={pushing}
                    >
                      {pushing && (
                        <span>{t('Pushing...')}</span>
                      )}

                      {!pushing && (
                        <span>{t('Push all')}</span>
                      )}
                    </Button>
                  </CardBody>
                </Card>

                <Card>
                  <CardHeader className="text-uppercase bg-transparent border-bottom">{t('Items Manifest')}</CardHeader>
                  <CardBody className="fs-5">
                    <div className="vstack gap-2">
                      {data !== null && data.items && data.items.map((x) => (
                        <div className="hstack gap-3" key={x.id}>
                          <div>
                            <img style={{ maxWidth: '94px', maxHeight: '94px' }} className="img-thumbnail" alt="thumb" src={`/api/items/thumbnail/${x.id}`} />
                          </div>
                          <div>
                            <small>{x.id}</small>
                          </div>
                          <div>
                            <Link to={`/item/${x.id}`}>
                              {`${x.manufacturer} ${x.part_number}`}
                            </Link>
                          </div>
                          <div>
                            <small>{x.condition}</small>
                          </div>
                          <div>
                            <strong>{`x${x.item_qty}`}</strong>
                          </div>
                        </div>
                      ))}
                    </div>
                  </CardBody>
                </Card>
              </>
            )}
          </Col>
        </Row>

        {data && (
          <Row>
            <Col lg="12">
              <Nav tabs>
                <NavItem>
                  <NavLink
                    style={{ cursor: 'pointer' }}
                    className={classnames({
                      active: (activeTab === '1'),
                    })}
                    onClick={() => {
                      toggle('1');
                    }}
                  >
                    {t('Sales')}
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    style={{ cursor: 'pointer' }}
                    className={classnames({
                      active: (activeTab === '2'),
                    })}
                    onClick={() => {
                      toggle('2');
                    }}
                  >
                    {t('Compatibility')}
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    style={{ cursor: 'pointer' }}
                    className={classnames({
                      active: (activeTab === '3'),
                    })}
                    onClick={() => {
                      toggle('3');
                    }}
                  >
                    {t('Fuse Families')}
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent
                activeTab={activeTab}
              >
                <TabPane tabId="1">
                  <Card className="border border-light border-top-0" style={{ borderRadius: '0px' }}>
                    <CardBody>
                      <BaseGrid
                        url="/api/sales"
                        hasSearch
                        filters={`items.listing_id=${id}`}
                        config={
                        {
                          columns: {
                            id: {
                              label: 'ID',
                              sort: true,
                              link: {
                                to: '/sales/%id%',
                              },
                            },
                            created_at: {
                              label: 'Imported',
                              date: {
                                format: (date) => (moment(date).fromNow()),
                                timezone: process.env.LOCAL_TZ,
                              },
                              sort: true,
                            },
                            reference1: {
                              label: 'Ref 1',
                              html: true,
                              sort: true,
                              link: {
                                to: '/sales/%id%',
                              },
                              format: (e, x) => {
                                if (x.canceled_at !== null) {
                                  return `<strike class="text-danger">${x.reference1}</strike>`;
                                }

                                return x.reference1;
                              },
                            },
                            reference2: { label: 'Ref 2', sort: true },
                            platform: { label: 'Platform', sort: false },
                            customer_email: { label: 'Email', style: { width: '120px' }, sort: true },
                            billing_name: { label: 'Billing Name', sort: true, format: (e, x) => (`${x.billing_firstname} ${x.billing_lastname}`) },
                            shipping_name: { label: 'Shipping Name', sort: true, format: (e, x) => (`${x.shipping_firstname} ${x.shipping_lastname}`) },
                            total_paid: {
                              label: 'Total Paid', sort: true, style: { width: '100px' }, format: (e, x) => (`${x.total_paid} ${x.currency_code}`),
                            },
                            refunds: {
                              label: t('Refunds'),
                              sort: false,
                              style: { width: '100px' },
                              html: true,
                              format: (e, x) => {
                                if (x.refunds && x.refunds.length > 0) {
                                  return x.refunds.map((r) => {
                                    const reason = r.reason?.toLowerCase().trim();
                                    if (['no longer needed',
                                      'too small',
                                      'too large',
                                      'wrong item was sent',
                                      'rts',
                                      'ordered wrong item',
                                      'item arrived too late',
                                      'didn\'t approve purchase',
                                      'oos',
                                      'received wrong item',
                                      'product and shipping box both damaged'].includes(reason)) {
                                      return `<span title="${r.reason}" class="text-danger">✅</span>`;
                                    }
                                    if (['item defective or doesn’t work',
                                      'item is defective or is not working',
                                      'incompatible or not useful',
                                      'inaccurate website description',
                                      'wrong part ordered',
                                      'incompatible',
                                      'missing parts or accessories',
                                      'incompatible or not useful',
                                      'product damaged, but shipping box ok',
                                      'item damage'].includes(reason)) {
                                      return `<span title="${r.reason}" class="text-success">❌</span>`;
                                    }
                                    return r.reason;
                                  }).join(', ');
                                }

                                return '';
                              },
                            },
                            distributions: {
                              label: t('Substitutes'),
                              sort: false,
                              style: { width: '100px' },
                              html: true,
                              format: (e, x) => {
                                if (x.distributions && x.distributions.length > 0) {
                                  return x.distributions.filter((d) => d.items.some((i) => i.original_substituted_item_id !== null)).map((dd) => dd.items.filter((i) => i.original_substituted_item_id !== null).map((i) => `<a href="/item/${i.original_substituted_item_id}">${i.sub_item.part_number}</a>`).join(', ')).join(', ');
                                }

                                return '';
                              },
                            },
                          },
                          pagination: {
                            sort: 'id',
                            direction: 'desc',
                            perPage: 30,
                          },
                        }
                        }
                      />
                    </CardBody>
                  </Card>
                </TabPane>

                <TabPane tabId="2">
                  <Card className="border border-light border-top-0" style={{ borderRadius: '0px' }}>
                    <CardBody>
                      <BaseGrid
                        url={`/api/listings/compatibility/${id}`}
                        hasSearch
                        create={() => toastr.warning('Not available yet')}
                        createText="Add Devices"
                        config={
                        {
                          columns: {
                            id: {
                              label: 'ID',
                              sort: true,
                            },
                            brand: { label: props.t('Brand'), sort: true },
                            model: { label: props.t('Model'), sort: true },
                            version: { label: props.t('Version'), sort: false },
                            type: { label: props.t('Type'), sort: true },
                            product_type: { label: props.t('Sub Type'), sort: true },
                            size: { label: props.t('Size'), sort: true },
                            marketing_title: { label: props.t('Title'), sort: true },
                            production_year: { label: props.t('Year'), sort: true },
                            color_finish: { label: props.t('Color/Finish'), sort: false },
                          },
                          pagination: {
                            sort: 'id',
                            direction: 'desc',
                            perPage: 30,
                          },
                        }
                        }
                      />
                    </CardBody>
                  </Card>
                </TabPane>

                <TabPane tabId="3">
                  <Card className="border border-light border-top-0" style={{ borderRadius: '0px' }}>
                    <CardBody>
                      <BaseGrid
                        url="/api/fuse/family"
                        hasSearch
                        filters={`listing_id=${data?.id}`}
                        config={
                        {
                          columns: {
                            id: {
                              label: 'ID',
                              sort: true,
                            },
                            name: { label: props.t('Name'), sort: true },
                            qty: { label: props.t('Qty'), sort: true },
                            description: { label: props.t('Description'), sort: false },
                          },
                          pagination: {
                            sort: 'id',
                            direction: 'desc',
                            perPage: 30,
                          },
                        }
                        }
                      />
                    </CardBody>
                  </Card>
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        )}
      </div>

      {isGallery ? (
        <Lightbox
          mainSrc={data.images[imageIndex].url}
          enableZoom={false}
          onCloseRequest={() => setIsGallery(false)}
          imageCaption={data.images[imageIndex].label}
        />
      ) : null}
    </div>
  );
}

ViewListing.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(ViewListing));
